module.exports = __webpack_public_path__ + "img/coins_icon.6475a6a5.png";